<template>
  <main class="paybill-pay-pc">
    <section class="paybill-card" aria-labelledby="paybill-title">
      <header class="paybill-header">
        <div class="paybill-mark">M</div>
        <div>
          <h1 id="paybill-title">M-Pesa PayBill</h1>
          <p>Complete this repayment from your M-Pesa menu.</p>
        </div>
      </header>

      <div class="amount-block">
        <span>Amount</span>
        <strong>{{ currencyCode }} {{ amount }}</strong>
      </div>

      <div class="payment-details">
        <div class="payment-detail">
          <div>
            <span>PayBill Number</span>
            <strong>{{ shortCode || '--' }}</strong>
          </div>
          <button type="button" title="Copy PayBill number" aria-label="Copy PayBill number" @click="onCopy(shortCode)">
            <img src="@/assets/copy.png" alt="" />
          </button>
        </div>
        <div class="payment-detail">
          <div>
            <span>Bill Reference</span>
            <strong>{{ billReference }}</strong>
          </div>
          <button type="button" title="Copy Bill Reference" aria-label="Copy Bill Reference" @click="onCopy(billReference)">
            <img src="@/assets/copy.png" alt="" />
          </button>
        </div>
      </div>

      <ol class="instructions">
        <li>Open M-Pesa and choose <b>Lipa na M-Pesa</b>, then <b>PayBill</b>.</li>
        <li>Enter the PayBill Number and Bill Reference shown above.</li>
        <li>Confirm the amount and complete payment on your phone.</li>
      </ol>

      <div class="waiting-state">
        <span></span>
        Waiting for your payment. This page updates automatically.
      </div>
      <div v-if="hr !== undefined" class="timer">Time remaining: {{ hr }}:{{ min }}:{{ sec }}</div>
    </section>
  </main>
</template>

<script>
import logic from "./index.js";

export default {
  name: "SafaricomPayBillComputer",
  mixins: [logic],
};
</script>

<style lang="scss" scoped>
.paybill-pay-pc {
  max-width: 520px;
  margin: 40px auto;
}

.paybill-card {
  background: #fff;
  border: 1px solid #e4e8e5;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(34, 58, 45, 0.08);
  padding: 28px;
}

.paybill-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 26px;

  h1 {
    color: #183d2b;
    font-size: 20px;
    margin: 0;
  }

  p {
    color: #718077;
    font-size: 13px;
    margin: 5px 0 0;
  }
}

.paybill-mark {
  align-items: center;
  background: #2f9d57;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 19px;
  font-weight: 700;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.amount-block {
  background: #f6faf7;
  border: 1px solid #e1ece4;
  padding: 16px;
  text-align: center;

  span, strong {
    display: block;
  }

  span {
    color: #718077;
    font-size: 12px;
  }

  strong {
    color: #183d2b;
    font-size: 23px;
    margin-top: 5px;
  }
}

.payment-details {
  border: 1px solid #e4e8e5;
  margin-top: 18px;
}

.payment-detail {
  align-items: center;
  border-bottom: 1px solid #e4e8e5;
  display: flex;
  justify-content: space-between;
  padding: 16px;

  &:last-child {
    border-bottom: 0;
  }

  span, strong {
    display: block;
  }

  span {
    color: #718077;
    font-size: 12px;
  }

  strong {
    color: #183d2b;
    font-size: 16px;
    margin-top: 5px;
    overflow-wrap: anywhere;
  }

  button {
    align-items: center;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    flex: 0 0 32px;
    height: 32px;
    justify-content: center;
    margin-left: 12px;
    padding: 6px;
  }

  button:hover {
    background: #edf6ef;
  }

  img {
    height: 18px;
    width: 18px;
  }
}

.instructions {
  color: #4d5b52;
  font-size: 13px;
  line-height: 1.55;
  margin: 20px 0;
  padding-left: 20px;

  li + li {
    margin-top: 7px;
  }
}

.waiting-state {
  align-items: center;
  color: #417052;
  display: flex;
  font-size: 12px;
  gap: 8px;
}

.waiting-state span {
  animation: pulse 1.5s ease-in-out infinite;
  background: #2f9d57;
  border-radius: 50%;
  height: 8px;
  width: 8px;
}

.timer {
  color: #718077;
  font-size: 12px;
  margin-top: 12px;
  text-align: center;
}

@keyframes pulse {
  50% { opacity: 0.35; }
}
</style>
